import engine from 'store/src/store-engine'
import sessionStorage from 'store/storages/sessionStorage'

const storages = [sessionStorage]
const store = engine.createStore(storages)

/** @see https://www.npmjs.com/package/store */
export default {
  // 后缀标识
  suffix: '_deadtime',

  /**
   * 获取
   * @param {string} key 关键字
   */
  get(key) {
    if (this.isExpired(key)) this.remove(key) // 如果过期则清除
    return store.get(key)
  },

  /**
   * 获取全部
   */
  info() {
    const d = {}

    store.each(function (value, key) {
      d[key] = value
    })

    return d
  },

  /**
   * 设置
   * @param {string} key 关键字
   * @param {*} value 值
   * @param {number} expires 过期时间(s)
   */
  set(key, value, expires) {
    store.set(key, value)

    if (expires) {
      store.set(`${key}${this.suffix}`, Date.parse(String(new Date())) + expires * 1000)
    }
  },

  /**
   * 是否过期
   * @param {string} key 关键字
   */
  isExpired(key) {
    return this.getExpiration(key) - Date.parse(String(new Date())) <= 2000
  },

  /**
   * 获取到期时间
   * @param {string} key 关键字
   */
  getExpiration(key) {
    return store.get(key + this.suffix, Number.MAX_VALUE)
  },

  /**
   * 移除
   * @param {string} key 关键字
   */
  remove(key) {
    store.remove(key)
    this.removeExpiration(key)
  },

  /**
   * 移除到期时间
   * @param {string} key 关键字
   */
  removeExpiration(key) {
    store.remove(key + this.suffix)
  },

  /**
   * 清理
   */
  clearAll() {
    store.clearAll()
  },
}
